// Default period (in days) for the history and monitoring lists
export const DEFAULT_DAYS_OF_HISTORY = 30;
// The History start date can be at most this many days ago
export const MAX_DAYS_OF_HISTORY = 45;
